import React, { FC, HTMLAttributes, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectActiveProperty } from '@hkm/components/Menu/PropertySelector/domain/selectors';
import DatetimeFormElement, {
  DatetimeVariant
} from '@hkm/components/shared/DatetimeFormElement/DatetimeFormElement';
import { createLocalTimeFromTzTime } from '@hkm/utils/dateHelper';
import classNames from 'classnames';

import { AcBadge } from '@ac/mobile-components/dist/components/badge';
import { AcFlex } from '@ac/mobile-components/dist/components/flex';
import { AcText } from '@ac/mobile-components/dist/components/text';
import {
  AlignItems,
  Color,
  JustifyContent,
  TextSize
} from '@ac/mobile-components/dist/enums';
import { Testable } from '@ac/mobile-components/dist/interfaces/componentProps';
import { getTestSelectorProp } from '@ac/mobile-components/dist/utils';

import './GuestServiceBadge.css';

interface Props extends HTMLAttributes<HTMLDivElement>, Testable {
  serviceDeferredUntil?: string;
}

const GuestServiceBadge: FC<Props> = ({
  testSelector,
  className: classNameProp,
  serviceDeferredUntil,
  ...rest
}) => {
  const { t } = useTranslation();
  const className = classNames('service-deferred-badge', classNameProp);

  const property = useSelector(selectActiveProperty);
  const deferredTime = createLocalTimeFromTzTime(
    serviceDeferredUntil,
    property.timeZoneCode
  );

  return (
    <AcFlex className={className} alignItems={AlignItems.center} {...rest}>
      <AcBadge
        borderColor={Color.Gray4}
        backgroundColor={Color.White}
        className="service-deferred-badge-element"
        {...getTestSelectorProp(testSelector, 'service-deferred')}
        badgeText={t('GLOBAL.GUEST_SERVICE_STATUS.VALUES.serviceDeferred')}
      />
      {deferredTime ? (
        <>
          <DatetimeFormElement
            className="ac-spacing-left-sm"
            smallText={true}
            timeLabel={t('GLOBAL.GUEST_SERVICE_STATUS.PREFERRED_TIME')}
            color={Color.ServiceDeferred}
            variant={DatetimeVariant.onlyTime}
            datetime={deferredTime}
            flatAndJustify={JustifyContent.center}
          />
        </>
      ) : (
        <AcText
          size={TextSize.Main2}
          className="ac-spacing-left-sm"
          {...getTestSelectorProp(testSelector, 'service-deferred-time')}
        >
          {t('GLOBAL.NO_TIME')}
        </AcText>
      )}
    </AcFlex>
  );
};

export default memo(GuestServiceBadge);



// WEBPACK FOOTER //
// ./src/components/shared/GuestService/GuestServiceBadge.tsx